// extracted by mini-css-extract-plugin
export default {"label":"ReactionPopover__label__DVF6P","popover":"ReactionPopover__popover__Bu0zs"};